import Title, { TITLE_SIZE as TITLE_SIZE_AUX } from '@/components/title';

export const THEMES = {
  SHORT: 'SHORT',
  NORMAL: 'NORMAL',
  LONG: 'LONG',
  FULL: 'FULL',
};
export const TITLE_SIZE = TITLE_SIZE_AUX;
function FormTemplate({
  action,
  titleText = '',
  titleSize = TITLE_SIZE.TITLE6,
  children = null,
  cyData = '',
  theme = THEMES.NORMAL,
  step = null,
  withHorizontalSeparator = false,
  boldTitle = true,
}) {
  const themeCss = {
    SHORT: 'col-xl-4 col-lg-5 col-sm-10 col-xs-12',
    NORMAL: 'col-xl-7 col-lg-8 col-sm-10 col-xs-12',
    LONG: 'col-xl-9 col-lg-10 col-sm-11 col-xs-12',
    FULL: 'col-xl-12 col-lg-12 col-sm-12 col-xs-12',
  };
  return (
    <>
      {titleText && (
        <Title
          text={titleText}
          size={titleSize}
          cyData={`${cyData}-title`}
          action={action}
          step={step}
          boldTitle={boldTitle}
        />
      )}
      <div className="form-template row" data-cy={cyData}>
        <div className={themeCss[theme]}>
          {children}
          {withHorizontalSeparator && <div className="horizontal-separator" />}
        </div>
      </div>
      <style jsx>
        {`
          @import '../../styles/colors.scss';
          .form-template {
          }
          .horizontal-separator {
            border-top: 1px solid $color-gp--grey2;
            margin-top: 12px;
          }
        `}
      </style>
    </>
  );
}

export default FormTemplate;
